import { axios } from '../axios'
import {
  CreateInteractiveSchemaReportDto,
  UpdateInteractiveSchemaReportDto,
  CreateFindingDto,
  UpdateFindingDto,
  CreateDiverDto,
  UpdateDiverDto,
} from './interactive-schema-types'

export async function getInteractiveSchemas(customerId: number, activeOnly = true) {
  const { data } = await axios.get(`customers/${customerId}/interactive-schemas`, { params: { activeOnly } })
  return data
}

export async function getInteractiveSchemasByEquipmentType(customerId: number, equipmentTypeId: number) {
  const { data } = await axios.get(`customers/${customerId}/interactive-schemas/by-equipment-type/${equipmentTypeId}`)
  return data
}

export async function getInteractiveSchemaById(customerId: number, id: number) {
  const { data } = await axios.get(`customers/${customerId}/interactive-schemas/${id}`)
  return data
}

export async function createInteractiveSchema(customerId: number, dto: any) {
  const { data } = await axios.post(`customers/${customerId}/interactive-schemas`, dto)
  return data
}

export async function updateInteractiveSchema(customerId: number, id: number, dto: any) {
  const { data } = await axios.put(`customers/${customerId}/interactive-schemas/${id}`, dto)
  return data
}

export async function deleteInteractiveSchema(customerId: number, id: number) {
  const { data } = await axios.delete(`customers/${customerId}/interactive-schemas/${id}`)
  return data
}

export async function createInteractiveSchemaReport(dto: CreateInteractiveSchemaReportDto) {
  const { data } = await axios.post('interactive-schema-reports', dto)
  return data
}

export async function getInteractiveSchemaReportById(id: number) {
  const { data } = await axios.get(`interactive-schema-reports/${id}`)
  return data
}

export async function updateInteractiveSchemaReport(id: number, dto: UpdateInteractiveSchemaReportDto) {
  const { data } = await axios.put(`interactive-schema-reports/${id}`, dto)
  return data
}

export async function updateReportData(id: number, reportDataJson: string) {
  const { data } = await axios.patch(`interactive-schema-reports/${id}/report-data`, JSON.stringify(reportDataJson), {
    headers: { 'Content-Type': 'application/json' },
  })
  return data
}

export async function updateReportStatus(id: number, status: number) {
  const { data } = await axios.patch(`interactive-schema-reports/${id}/status`, null, {
    params: { status },
  })
  return data
}

export async function completeReport(id: number) {
  const { data } = await axios.patch(`interactive-schema-reports/${id}/complete`)
  return data
}

export async function approveReport(id: number) {
  const { data } = await axios.post(`interactive-schema-reports/${id}/approve`)
  return data
}

export async function deleteReport(id: number) {
  const { data } = await axios.delete(`interactive-schema-reports/${id}`)
  return data
}

export async function getReportsByEquipmentId(equipmentId: number) {
  const { data } = await axios.get(`interactive-schema-reports/equipment/${equipmentId}`)
  return data
}

export async function getReportsBySchemaId(schemaId: number) {
  const { data } = await axios.get(`interactive-schema-reports/schema/${schemaId}`)
  return data
}

export async function getReportsByCustomerId(customerId: number, status?: number, fromDate?: string, toDate?: string) {
  const { data } = await axios.get(`interactive-schema-reports/customer/${customerId}`, {
    params: { status, fromDate, toDate },
  })
  return data
}

export async function getFindingsByReportId(reportId: number) {
  const { data } = await axios.get(`interactive-schema-reports/${reportId}/findings`)
  return data
}

export async function addFinding(reportId: number, dto: CreateFindingDto) {
  const { data } = await axios.post(`interactive-schema-reports/${reportId}/findings`, dto)
  return data
}

export async function updateFinding(reportId: number, findingId: number, dto: UpdateFindingDto) {
  const { data } = await axios.put(`interactive-schema-reports/${reportId}/findings/${findingId}`, dto)
  return data
}

export async function deleteFinding(reportId: number, findingId: number) {
  const { data } = await axios.delete(`interactive-schema-reports/${reportId}/findings/${findingId}`)
  return data
}

export async function addFindings(reportId: number, findings: CreateFindingDto[]) {
  const { data } = await axios.post(`interactive-schema-reports/${reportId}/findings/bulk`, findings)
  return data
}

export async function deleteAllFindings(reportId: number) {
  const { data } = await axios.delete(`interactive-schema-reports/${reportId}/findings`)
  return data
}

export async function getDivers(customerId: number) {
  const { data } = await axios.get(`customers/${customerId}/divers`)
  return data
}

export async function createDiver(customerId: number, dto: CreateDiverDto) {
  const { data } = await axios.post(`customers/${customerId}/divers`, dto)
  return data
}

export async function updateDiver(customerId: number, id: number, dto: UpdateDiverDto) {
  const { data } = await axios.put(`customers/${customerId}/divers/${id}`, dto)
  return data
}

export async function deleteDiver(customerId: number, id: number) {
  const { data } = await axios.delete(`customers/${customerId}/divers/${id}`)
  return data
}

export async function getReportsByMainComponentId(mainComponentId: number) {
  const { data } = await axios.get(`interactive-schema-reports/by-main-component/${mainComponentId}`)
  return data
}
